import { render, staticRenderFns } from "./infektionsrisiko-gantt.vue?vue&type=template&id=6a952b58&"
import script from "./infektionsrisiko-gantt.vue?vue&type=script&lang=js&"
export * from "./infektionsrisiko-gantt.vue?vue&type=script&lang=js&"
import style0 from "./infektionsrisiko-gantt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports